export default {"src":"https://cdn.sa-tech.de/homeone/main/_next/static/media/hexagon.ab070308.svg","height":55,"width":50,"blurWidth":0,"blurHeight":0};